// Textos do Mapa das fazendas, coletados por glob em core/i18n/messages.ts.
const pt = {
  'farm.mapa.grupo': 'Todos',
  'farm.mapa.escolherImovel': 'Escolher o imóvel',
  'farm.mapa.visao': 'Visão do desenho',
  'farm.mapa.perspectiva': 'Perspectiva',
  'farm.mapa.camadas': 'Camadas',
  'farm.mapa.ilustrativo': 'Desenho ilustrativo até chegar o CAR de cada imóvel',
  'farm.mapa.glebasTotal': '{{n}} glebas',
  'farm.mapa.destacar': 'Destacar',
  'farm.mapa.tudo': 'Tudo',
  'farm.mapa.currais': 'Currais',
  'farm.mapa.cliqueNoImovel': 'Clique num imóvel para abrir o desenho dele',
  'farm.mapa.naoEncontrado': 'Imóvel não encontrado no mapa',
  'farm.mapa.erro': 'Não foi possível carregar o mapa',
  'farm.mapa.tentarDeNovo': 'Tentar de novo',
  'farm.mapa.historico': 'Histórico',
  'farm.mapa.semHistorico': 'Sem histórico de safra para esta gleba',
  'farm.mapa.fechar': 'Fechar',
  'farm.mapa.area': 'Área',
  'farm.mapa.agora': 'Safra atual',
  'farm.mapa.inicio': 'Início',
  'farm.mapa.fim': 'Fim',
  'farm.mapa.resultado': 'Resultado',
  'farm.mapa.abrirNoMapa': 'Abrir no mapa',
  'farm.mapa.semDesenho': 'Desenho do imóvel ainda não cadastrado',
  'farm.mapa.semDesenhoGrupo': 'Desenho dos imóveis ainda não cadastrado',
  'farm.mapa.semDesenhoDica': 'O perímetro e as glebas aparecem aqui quando o desenho for carregado.',
}

export default { pt }
